import * as types from "./actionTypes";
import * as exception from "./exceptionActions";

export function loadSettings() {
	return function (dispatch) {
		const settings = {};

        if(!window.settings) {
            dispatch(exception.throwException(new Error('Settings not loaded')));
            return;
        }

		settings.apiRoot = window.settings.ApiRoot.toLowerCase() + "api";
		settings.siteRoot = window.settings.SiteRoot.toLowerCase();
		settings.helpdeskContactLink = window.settings.HelpdeskContactLink;
		settings.apiControllerPath = [];
		settings.fileTypes = window.settings.FileTypes;
		settings.maxAllowedContentLength = window.settings.MaxAllowedContentLength;
		settings.lockAllDossiers = (window.settings.LockAllDossiers == 'true');
		settings.topSportSjabloon = window.settings.TopsportSjabloon;
		settings.sportVlaanderenIconsURL = window.settings.SportVlaanderenIconsURL;
		settings.bewijsVanFinancierURL = window.settings.BewijsVanFinancierURL;
		settings.voorbeeldInplantingsplanURL = window.settings.VoorbeeldInplantingsplanURL;
		settings.spinnerTimeout = window.settings.SpinnerTimeout;
		settings.maxMapFeaturesToLoad = window.settings.MaxMapFeaturesToLoad;
		settings.osmBaseLayerUrl = window.settings.OSMBaseLayerUrl;

		dispatch(readSettingsSuccess(settings));
	};
}

export function getSettings() {
	return (dispatch, getState) => {
		const state = getState();
		return state;
	};
}

export function readSettingsSuccess(settings) {
	return {
		type: types.READ_SETTINGS_SUCCESS,
		data: settings
	};
}
